import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CrudImplementation} from '@shared/services/crud-implementation';

@Injectable({
  providedIn: 'root'
})
export class CrudAppdomainService extends CrudImplementation {
  protected url = '/v1/admin/appdomain';
}
